<template>
  <div>
    <!-- Trigger button -->
    <button
      @click="open"
      :class="cadastralNumber ? 'hover:bg-green-100' : 'opacity-60 cursor-not-allowed'"
      :disabled="!cadastralNumber || loading"
      type="button"
      class="px-4 h-10 bg-green-50 text-green-800 rounded-xl ml-2 flex items-center justify-center"
    >
      <span v-if="loading" class="el-icon-loading mr-1"></span>
      open.ngis.uz
      <i class="el-icon-view ml-2"></i>
    </button>

    <!-- Modal -->
    <div v-if="visible" class="modal fs-14 active">
      <div class="modal-cover" @click="close"></div>
      <div class="modal-item padding-map" style="width:95%; height:95%;">
        <div class="flex justify-between modal-absolute-header">
          <p class="modal-title">
            open.ngis.uz —
            <span class="font-bold text-indigo-800">
              {{ feature ? feature.attributes.cadastral_number : cadastralNumber }}
            </span>
          </p>
          <button style="font-size:16px;" @click="close">
            <i class="el-icon-close" style="font-weight:600;"></i>
          </button>
        </div>

        <div class="w-full map-item h-full">
          <div v-if="!feature" class="flex items-center justify-center h-full text-red-500">
            Ma'lumot topilmadi
          </div>
          <yandex-map
            v-else
            :coords="mapCenter"
            style="height:100%; width: 100%"
            :zoom="17"
            :controls="['zoomControl', 'typeSelector']"
            :show-all-markers="true"
          >
            <ymap-marker
              v-if="polygonCoords"
              marker-id="ngis-polygon"
              marker-type="polygon"
              :coords="polygonCoords"
              :marker-fill="{ enabled: true, color: '#f9731655', opacity: 0.3 }"
              :marker-stroke="{ color: '#ea580caa', width: 2, opacity: 0.7 }"
            />
          </yandex-map>
        </div>

        <div class="flex w-full justify-between modal-bottom fw-w">
          <div class="modal-inputes flex items-center flex-wrap gap-4 fs-14">
            <template v-if="feature">
              <p>
                <b>{{ $t('cadaster_number') }}:</b>
                {{ feature.attributes.cadastral_number }}
              </p>
              <p v-if="feature.attributes.region_name">
                <b>{{ $t('region') }}:</b> {{ feature.attributes.region_name }}
              </p>
              <p v-if="feature.attributes.district_name">
                <b>{{ $t('district') }}:</b> {{ feature.attributes.district_name }}
              </p>
              <p v-if="feature.attributes.mahalla_name">
                <b>МФЙ:</b> {{ feature.attributes.mahalla_name }}
              </p>
            </template>
          </div>
          <div class="flex justify-center items-center">
            <button @click="close" class="light-button h-10">
              {{ $t("close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NgisMapModal",
  props: {
    cadastralNumber: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      ngisData: null,
    };
  },
  computed: {
    feature() {
      return this.ngisData?.features?.[0] || null;
    },
    polygonCoords() {
      if (!this.feature?.geometry?.rings) return null;
      return this.feature.geometry.rings.map((ring) =>
        ring.map(([x, y]) => {
          const lng = (x / 20037508.34) * 180;
          const lat =
            (Math.atan(Math.exp((y / 20037508.34) * Math.PI)) * 360) /
              Math.PI -
            90;
          return [lat, lng];
        })
      );
    },
    mapCenter() {
      if (!this.polygonCoords) return [41.2995, 69.2401];
      const ring = this.polygonCoords[0];
      const lats = ring.map((c) => c[0]);
      const lngs = ring.map((c) => c[1]);
      return [
        (Math.min(...lats) + Math.max(...lats)) / 2,
        (Math.min(...lngs) + Math.max(...lngs)) / 2,
      ];
    },
  },
  methods: {
    open() {
      if (!this.cadastralNumber) return;
      this.loading = true;
      const query = {
        f: "pjson",
        maxAllowableOffset: 1,
        resultRecordCount: 1,
        where: `(cadastral_number = '${this.cadastralNumber}')`,
        outFields: "*",
        outSR: 102100,
        spatialRel: "esriSpatialRelIntersects",
      };
      const url = `https://db.ngis.uz/db/rest/services/UZKAD/NOTURAR_UZKAD_DB16/FeatureServer/0/query`;
      axios
        .get(url, { params: query, headers: null })
        .then((response) => {
          this.ngisData = response.data;
          this.visible = true;
        })
        .catch((err) => {
          console.error("open.ngis.uz xatosi:", err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.visible = false;
    },
  },
};
</script>
